import { render, staticRenderFns } from "./fluxPollDetail.vue?vue&type=template&id=84b495ac&scoped=true&"
import script from "./fluxPollDetail.vue?vue&type=script&lang=js&"
export * from "./fluxPollDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b495ac",
  null
  
)

export default component.exports